/*
 * File Created: Friday, 5th May 2023 6:03:21 pm
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2023 Addble Solutions Private Limited. All Rights Reserved.
 */
import { Theme, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
// import { CgArrowRight } from "react-icons/cg";
import { MdOutlineShoppingCart } from "react-icons/md";
import React from "react";
// import { Colors } from "../../constants/color";
// import test from "../../assets/images/sst_4_nobg.png";
import Button from "../Button";
import CartItem from "./CartItem";
import { CartContext } from "../../context/cartContext.context";
import { Colors } from "../../constants/color";
import bannerBgImg from "../../assets/images/testimonial_bg_shap.png";
import { useNavigate } from "react-router-dom";
import OrderForm from "../form/OrderForm";

function Cart() {
  const theme: Theme = useTheme();
  const [totalAmount, setTotalAmount] = React.useState<string>("");
  const { items, getTotalItemAmount } = React.useContext(CartContext);
  const navigate = useNavigate();

  function handleReturnHomeButton() {
    navigate("/");
  }

  React.useEffect(() => {
    setTotalAmount((Math.round(getTotalItemAmount() * 100 + Number.EPSILON) / 100).toString());
    console.log("CART : TOTAL AMOUNT : ", totalAmount);
  }, [getTotalItemAmount, totalAmount])

  return (
    <React.Fragment>
      {/* <Box sx={{ ...theme.mixins.toolbar }} /> */}
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          padding: {
            xs: theme.spacing(1.5, 1),
            md: theme.spacing(1.5, 2),
            lg: theme.spacing(1.5, 8),
            xl: theme.spacing(1.5, 20),
          },
        }}
      > */}
      <Box
        sx={{
          height: { xs: "170px" },
          backgroundImage: `url(${bannerBgImg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
          backgroundSize: "100% auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          // marginBottom: theme.spacing(2),
          backgroundColor: "#eeeeee",
          color: Colors.black,
        }}
      >
        <Typography variant="h5" fontWeight="500">
          Shopping Cart
        </Typography>
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: {
            xs: theme.spacing(1.5, 1),
            md: theme.spacing(1.5, 2),
            lg: theme.spacing(1.5, 8),
            xl: theme.spacing(1.5, 20),
          },
        }}
      >
        <Breadcrumbs separator=">">
          <Link className="breadCrumb" color="text.primary" underline="hover" href="/">
            Home
          </Link>
          <Link className="breadCrumb" color="text.primary" underline="none">
            Order
          </Link>
        </Breadcrumbs>
      </Box> */}
      {/* <Divider /> */}
      <Box
        sx={{
          padding: {
            xs: theme.spacing(1.5, 1),
            md: theme.spacing(1.5, 2),
            lg: theme.spacing(1.5, 8),
            xl: theme.spacing(1.5, 20),
          },
        }}
      >
        {items?.length === 0 ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: {
                xs: theme.spacing(10, 0),
              },
            }}
          >
            <Avatar
              sx={{
                backgroundColor: "transparent",
                color: "#6c757d",
                width: theme.spacing(15),
                height: theme.spacing(15),
              }}
            >
              <MdOutlineShoppingCart style={{ fontSize: theme.spacing(12) }} />
            </Avatar>
            <Typography>No product added to the cart</Typography>
            <Box
              sx={{
                marginBlock: theme.spacing(3.7),
              }}
            >
              <Button
                title="Return to shop"
                sx={{
                  borderRadius: 0,
                  padding: "11.5px 15px",
                  border: `1px solid ${Colors.fallow}`,
                  backgroundColor: Colors.fallow,
                  color: Colors.white,
                  "&:hover": {
                    backgroundColor: "#007bff",
                  },
                }}
                onClick={handleReturnHomeButton}
              />
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              paddingBlock: theme.spacing(2.5),
              paddingInline: { xs: 0, sm: theme.spacing(10), md: 0 },
              // gap: 1,
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "75%" },
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  width: "calc(100% - 28px)",
                  // backgroundColor: "green",
                  display: { xs: "none", md: "flex"},
                  flexDirection: "row",
                }}
              >
                <Box
                  sx={{
                    flexGrow: 1,
                    color: Colors.dusty_gray,
                  }}
                >
                  <Typography variant="body1">Product</Typography>
                </Box>
                <Box
                  sx={{
                    width: {xs: "54%" },
                    display: "flex",
                    flexDirection: "row",
                    padding: theme.spacing(0, 0, 2, 0),
                    // backgroundColor: "indigo",
                    "& .cart_header": {
                      width: "40%",
                      color: Colors.dusty_gray,
                      // border: `1px solid #${Math.floor(Math.random()*16777215).toString(16)}`,
                    },
                  }}
                >
                  <Typography variant="body1" sx={{ width: "30%", color: Colors.dusty_gray,}}>Price</Typography>
                  <Typography className="cart_header" variant="body1">Quantity</Typography>
                  <Typography variant="body1" sx={{ width: "30%", color: Colors.dusty_gray,}}>Total</Typography>
                </Box>
              </Box>
              {items?.map((item) => {
                return <CartItem key={item.id} {...item} />;
              })}
            </Box>
            <Box
              sx={{
                width: { xs: "100%", md: "30%" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: { xs: "center", md: "start" },
                marginBlock: { xs: theme.spacing(3.7), md: 0 },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1.5,
                  padding: theme.spacing(0, 2, 1, 2),
                }}
              >
                <Typography variant="h6" fontWeight="600">
                  Cart Total
                </Typography>
                <Divider orientation="horizontal" flexItem />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    color: Colors.fallow,
                  }}
                >
                  <Typography variant="h6" fontWeight="400">
                    Total:
                  </Typography>
                  <Typography variant="h6">₹{totalAmount}</Typography>
                </Box>
              </Box>
              <OrderForm />
              {/* <Button title="Continue" endIcon={<CgArrowRight />} /> */}
            </Box>
          </Box>
        )}
        {/* <CartItem /> */}
      </Box>
      {/* </Box> */}
    </React.Fragment>
  );
}

export default Cart;
